import { IInputProps } from '../index'

interface IInputFieldProps extends IInputProps {
  className?: string
  focused: boolean
  setFocused: (value: boolean) => void
}

export const InputField = (props: IInputFieldProps) => {
  return (
    <input
      data-testid={props.__testId || 'inputField'}
      data-focused={props.focused}
      dir={props.dir}
      autoComplete={props.autocompleteOff ? 'disable' : props.autoComplete}
      aria-label={props.ariaLabel}
      maxLength={props.maxLength}
      className={props.className}
      id={props.id}
      ref={props.inputRef}
      type={props.type}
      onChange={(e) => props.onChange && props.onChange(e.target.value)}
      value={props.value as string}
      disabled={props.disabled}
      readOnly={props.readOnly}
      onFocus={() => {
        props.setFocused(true)
        props.onFocus && props.onFocus()
      }}
      onBlur={(event) => {
        props.setFocused(false)
        props.onBlur && props.onBlur(event)
      }}
      autoFocus={props.autoFocus}
      onSelect={props.onSelect}
      onKeyPress={props.onKeyPress}
      onKeyDown={props.onKeyDown}
      placeholder={!props.label ? props.placeholder : ''}
    />
  )
}
